export const useStudentsStore = defineStore('students', () => {
  const students = ref([])

  const setStudents = (newStudents) => {
    students.value = newStudents
  }

  const getStudents = computed(() => students.value)

  return {
    students,
    setStudents,
    getStudents,
  }
})
